import { SideNav } from "components";
import { HomeWrapper } from "components/CdBalance/style";
import CustomizedAccordion from "components/CustomizedAccordian";
import {
  BaseAccordian,
  LargeButton,
  MainBody,
  PageTitle,
} from "components/core";
import { ButtonWrapper } from "pages/PlanSelection";
import { WidthLimiter } from "pages/PlanSetup/styles";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import http from "services/httpService";

function ChooseProductToUploadUHID() {
  const navigate = useNavigate();
  const [convertedFormat, setConvertedFormat] = useState();
  const [numbers, setNumber] = useState(0);
  const [initials, setInitials] = useState();
  const { state } = useLocation();
  useEffect(async () => {
    try {
      const { data } = await http.get("business/userplans_data_selected/");
      localStorage.setItem("eb_selected_values", JSON.stringify(data));
      const newArray = Object.entries(data?.userplans_data).map(
        ([user_plan, value], index) => {
          const product_name =
            value?.product_type?.display_name ||
            value?.product_type?.product_type_name;
          return { [product_name]: user_plan };
        }
      );
      if (state) {
        setConvertedFormat(state.postFormat);
      } else {
        setConvertedFormat(newArray);
        setInitials(newArray);
        setNumber(newArray.length);
      }
    } catch (e) {
      alert("There are some error!");
    }
  }, []);
  const haldleSubmit = async () => {
    const correctData = JSON.parse(localStorage.getItem("correct_format"));
    if (!correctData) return;
    // if(Object.entries(correctData).length !== numbers){
    //   console.log(Object.entries(correctData).length, numbers);
    //   return
    // }
    const postData = Object.values(correctData);
    const resultArray = postData.map(
      ({
        uhid_file_id,
        userplan_id,
        invoice_id,
        payment_date,
        amount,
        net_premium,
        cgst,
        sgst,
        igst,
        employee_wise_breakup_sheet_id,
        // endorsement_number, //don't need the endorsment number at the 1st time upload data
      }) => ({
        uhid_file_id,
        userplan_id,
        invoice_id,
        payment_date,
        amount,
        net_premium,
        cgst,
        sgst,
        igst,
        employee_wise_breakup_sheet_id,
        // endorsement_number,
      })
    );
    try {
      const { data } = await http.post(
        "/business/upload_employee_issuance_data/",
        resultArray
      );
      localStorage.setItem("supertask_id", data);
      navigate("/super-task-reupload");
    } catch (e) {
      console.log(e);
    }
  };

  function sortPlans(planArray) {
    // Define the desired order of keys
    const sortOrder = {
      "Group Mediclaim Cover": 1,
      "Group Personal Accident": 2,
      "Group Term Life": 3,
    };

    // Sorting function
    planArray.sort((a, b) => {
      const keyA = Object.keys(a)[0]; // Get the key (plan name) of the first object
      const keyB = Object.keys(b)[0]; // Get the key (plan name) of the second object

      return sortOrder[keyA] - sortOrder[keyB];
    });

    return planArray;
  }

  return (
    <>
      <SideNav />
      <HomeWrapper>
        <PageTitle title="Upload Client IDs" />
        {console.log({ convertedFormat })}
        <WidthLimiter
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "2rem",
            paddingTop: "24px",
          }}
        >
          {convertedFormat &&
            sortPlans(convertedFormat).map((value, index) => {
              const [productType, userPlan] = Object.entries(value)[0];
              return (
                <CustomizedAccordion
                  productType={productType}
                  userPlan={userPlan}
                  postFormat={sortPlans(convertedFormat)}
                  key={index}
                />
              );
            })}
          <LargeButton
            onClick={() => haldleSubmit()}
            fontSize={"16px"}
            borderRadius={"10px"}
            width={"100px"}
            label={"Next"}
            marginTop={"70px"}
          />
        </WidthLimiter>
      </HomeWrapper>
    </>
  );
}

export default ChooseProductToUploadUHID;
